import {useEffect, useRef, useState} from 'react'


import '../assets/css/bibliaDigital.css'
import LateralMenu from './LateralMenu';
import GlobalVars from './subComponents/GlobalVars';
import fetchFunc from './funcionalidades/fetchFunc.jsx'
import BoxCompleta from './BoxCompleta.jsx';

// var width_ = window.innerWidth;
// var height_ = window.innerHeight;

export const Biblia = ({ativaResp}) => {

  const [selectedBook, setSelectedBook] = useState('default')
  const [chapterVal, setChapterVal] = useState(null)
  const [actualChapter, setActualChapter] = useState('')
  const [pesquisar, setPesquisar] = useState(false)
  const lateralMenu = useRef()

  useEffect(()=>{
    fetchFunc.fetchGet(`https://rafaelnodeapi.com.br/static/livrosBiblia/${selectedBook}/${selectedBook}_${chapterVal}.json`)
      .then(resp => resp.json())
      .then(resp => setActualChapter(resp.conteudo))
      .catch(resp => {
        fetchFunc.fetchGet(`https://rafaelnodeapi.com.br/static/livrosBiblia/${selectedBook}/${selectedBook}_1.json`)
        .then(resp => resp.json())
        .then(resp => setActualChapter(resp.conteudo))
      }
    )
  },[pesquisar])
  
    return <>
        <LateralMenu ativaResp={ativaResp} ref={lateralMenu}/>
        <div className="containerPrincipal bibliaDigital" style={{maxHeight: "100vh"}}>
        <BoxCompleta lateralMenu={lateralMenu}/>
        <div className="containerbiblia">

          <div className="topButtons">
            <div className="titlePage">Bíblia Digital</div>

            <select className="selectLivros"
                defaultValue="default"
                onChange={e => setSelectedBook(e.target.value)}>

              <option value="default">Selecione um livro</option>
              {Object.keys(GlobalVars.books).map((value)=>{
                  return <option value={value} key={value} >{GlobalVars.books[value]}</option>
              })}
              </select>

              {selectedBook === 'default' ? <></> : <>
                <input className='inputChapter' placeholder={`Capítulo: Ex.: 1`}
                onChange={e => setChapterVal(e.target.value)}/> </>}

          <div className='pesquisar'
            onClick={()=> {setPesquisar(!pesquisar)}}> Pesquisar </div>
          </div>

            <div className="divider"></div>

            {actualChapter != '' ?<div className="principal">
               {actualChapter.map((value)=>{
                  return <><span className='numberChapter' key={`chapter${value.number}`}>{value.number}. </span>
                  {value.text}</>
              }) }
            </div>: <></>}
        </div>

        </div>
    </>
}

export default Biblia;